import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from '../layout/AdminLayout';
import AdminDashboard from '../pages/admin/AdminDashboard';
import UserManagement from '../pages/admin/UserManagement';
import ShopManagement from '../pages/admin/ShopManagement';
import PlanManagement from '../pages/admin/PlanManagement';
import BlogManagement from '../pages/admin/BlogManagement';
import BlogEditor from '../pages/admin/BlogEditor';
import SystemLogs from '../pages/admin/SystemLogs';
import AdminSettings from '../pages/admin/AdminSettings';
import UserDetail from '../pages/admin/UserDetail';

const AdminRoutes = () => {
  return (
    <AdminLayout>
      <Routes>
        <Route path="/" element={<AdminDashboard />} />
        <Route path="/users" element={<UserManagement />} />
  <Route path="/users/:userId" element={<UserDetail />} />
        <Route path="/shops" element={<ShopManagement />} />
        <Route path="/plans" element={<PlanManagement />} />
        <Route path="/blog" element={<BlogManagement />} />
        <Route path="/blog/create" element={<BlogEditor />} />
        <Route path="/blog/edit/:id" element={<BlogEditor />} />
        <Route path="/logs" element={<SystemLogs />} />
        <Route path="/analytics" element={<div className="min-h-screen bg-gradient-to-b from-[#1f2937] to-[#111827] flex items-center justify-center">
          <div className="text-center text-white">
            <h2 className="text-2xl font-bold mb-4">Analytics Dashboard</h2>
            <p className="text-gray-400">Advanced analytics coming soon...</p>
          </div>
        </div>} />
        <Route path="/settings" element={<AdminSettings />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </AdminLayout>
  );
};

export default AdminRoutes;
